// @ts-nocheck
"use strict";
var Ajaxinate = function (config) {
    var settings = config || {},
        defaultSettings = { pagination: ".AjaxinatePagination", method: "scroll", container: ".AjaxinateLoop", offset: 0, loadingText: "Loading", callback: null };
    (this.settings = Object.assign(defaultSettings, settings)),
        (this.addScrollListeners = this.addScrollListeners.bind(this)),
        (this.addClickListener = this.addClickListener.bind(this)),
        (this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this)),
        (this.stopMultipleClicks = this.stopMultipleClicks.bind(this)),
        (this.destroy = this.destroy.bind(this)),
        (this.containerElement = document.querySelector(this.settings.container)),
        (this.paginationElement = document.querySelector(this.settings.pagination)),
        this.initialize();
};
(Ajaxinate.prototype.initialize = function () {
    if (this.containerElement) {
        var initializers = { click: this.addClickListener, scroll: this.addScrollListeners };
        initializers[this.settings.method]();
    }
}),
    (Ajaxinate.prototype.addScrollListeners = function () {
        this.paginationElement &&
            (document.addEventListener("scroll", this.checkIfPaginationInView), window.addEventListener("resize", this.checkIfPaginationInView), window.addEventListener("orientationchange", this.checkIfPaginationInView));
    }),
    (Ajaxinate.prototype.addClickListener = function () {
        this.paginationElement &&
            ((this.nextPageLinkElement = this.paginationElement.querySelector("a")), (this.clickActive = !0), this.nextPageLinkElement !== null && this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks));
    }),
    (Ajaxinate.prototype.stopMultipleClicks = function (event) {
        event.preventDefault(), this.clickActive && ((this.nextPageLinkElement.innerHTML = this.settings.loadingText), (this.nextPageUrl = this.nextPageLinkElement.href), (this.clickActive = !1), this.loadMore());
    }),
    (Ajaxinate.prototype.checkIfPaginationInView = function () {
        var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset,
            bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
        top <= window.innerHeight &&
            bottom >= 0 &&
            ((this.nextPageLinkElement = this.paginationElement.querySelector("a")),
            this.removeScrollListener(),
            this.nextPageLinkElement && ((this.nextPageLinkElement.innerHTML = this.settings.loadingText), (this.nextPageUrl = this.nextPageLinkElement.href), this.loadMore()));
    }),
    (Ajaxinate.prototype.loadMore = function () {
        (this.request = new XMLHttpRequest()),
            (this.request.onreadystatechange = function () {
                if (this.request.readyState === 4 && this.request.status === 200) {
                    var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0],
                        newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
                    this.containerElement.insertAdjacentHTML("beforeend", newContainer.innerHTML),
                        document.dispatchEvent(new CustomEvent('imgLoad', {bubbles: true}));
                        document.dispatchEvent(new CustomEvent('wishRefresh', { bubbles: true })); 
                        (this.paginationElement.innerHTML = newPagination.innerHTML),
                        this.settings.callback && typeof this.settings.callback == "function" && this.settings.callback(this.request.responseXML),
                        this.initialize();
                }
            }.bind(this)),
            this.request.open("GET", this.nextPageUrl),
            (this.request.responseType = "document"),
            this.request.send();
    }),
    (Ajaxinate.prototype.removeClickListener = function () {
        this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
    }),
    (Ajaxinate.prototype.removeScrollListener = function () {
        document.removeEventListener("scroll", this.checkIfPaginationInView), window.removeEventListener("resize", this.checkIfPaginationInView), window.removeEventListener("orientationchange", this.checkIfPaginationInView);
    }),
    (Ajaxinate.prototype.destroy = function () {
        var destroyers = { click: this.removeClickListener, scroll: this.removeScrollListener };
        return destroyers[this.settings.method](), this;
    });

//# sourceMappingURL=/s/files/1/0382/4185/files/ajaxinate.js.map


// Single shared instance. A new Ajaxinate is created after every filter fetch,
// so destroy (and abort) the previous one first – otherwise each instance loads
// the next page on its own and products are appended twice.
window.WI_endlessScroll = window.WI_endlessScroll || null;
function WI_initEndlessScroll() {
    var prev = window.WI_endlessScroll;
    if (prev) {
        // Ajaxinate.destroy() loses `this` (removeScrollListener is unbound), so
        // call the remover directly on the instance instead.
        try { prev.removeScrollListener(); } catch (e) {}
        if (prev.request && prev.request.readyState !== 4) {
            try { prev.request.abort(); } catch (e) {}
        }
        prev.containerElement = null;
    }
    window.WI_endlessScroll = new Ajaxinate({
        container: '#WI_mainCollection_grpGrid',
        pagination: '#collection-pagination',
        loadingText: '<div class="spinner-border"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 12C24 14.5342 23.1977 17.0033 21.7082 19.0534C20.2187 21.1036 18.1183 22.6296 15.7082 23.4127C13.2981 24.1958 10.7019 24.1958 8.2918 23.4127C5.88167 22.6296 3.78133 21.1036 2.2918 19.0534C0.802259 17.0033 -2.21542e-07 14.5342 0 12C2.21543e-07 9.46585 0.80226 6.99675 2.2918 4.94658C3.78133 2.8964 5.88168 1.37042 8.2918 0.587321C10.7019 -0.195774 13.2981 -0.195774 15.7082 0.587322L14.5957 4.01113C12.9087 3.46296 11.0913 3.46296 9.40426 4.01113C7.71717 4.55929 6.24693 5.62748 5.20426 7.0626C4.16158 8.49772 3.6 10.2261 3.6 12C3.6 13.7739 4.16158 15.5023 5.20426 16.9374C6.24693 18.3725 7.71717 19.4407 9.40426 19.9889C11.0913 20.537 12.9087 20.537 14.5957 19.9889C16.2828 19.4407 17.7531 18.3725 18.7957 16.9374C19.8384 15.5023 20.4 13.7739 20.4 12H24Z" fill="#111"></path></svg></div>'
    });
}
document.addEventListener("DOMContentLoaded", WI_initEndlessScroll);
document.addEventListener('filterFetched', WI_initEndlessScroll);
